export default __webpack_public_path__ + "static/media/void.922a8404.svg";